export const CANCEL_RESERVATION_KEY = 'CANCEL_RESERVATION'
